export const channels = {
  rootChannel: "RootChannel",
  statusChannel: "StatusChannel",
  conversationsChannel: "ConversationsChannel",
  messagesChannel: "MessagesChannel",
  notificationsChannel: "NotificationsChannel"
}
